import type { IconProps } from './types';
import './icons.css';

export default function Overdraft({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 18}
      height={height || 14}
      viewBox="0 0 18 14"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-overdraft ${className || ''}`}
      fill="none"
    >
      <rect width="18" height="14" fill="#808589" rx="4" />
      <path
        fill="#fff"
        d="M9.954 4.1h2.221c.501 0 .883.036 1.146.11.353.1.655.278.907.534s.444.57.575.942c.131.37.197.826.197 1.37 0 .477-.062.889-.185 1.234-.15.423-.365.764-.644 1.025-.211.198-.496.353-.854.464-.268.081-.627.122-1.076.122H9.954V4.1Zm1.216.98v3.844h.907c.34 0 .584-.019.735-.056.197-.047.36-.128.488-.241.132-.114.239-.3.32-.558.083-.261.124-.616.124-1.065 0-.448-.041-.793-.123-1.033a1.32 1.32 0 0 0-.345-.562 1.172 1.172 0 0 0-.563-.273c-.17-.037-.502-.055-.997-.055h-.546ZM3 7.036c0-.591.092-1.087.275-1.489.137-.295.323-.56.558-.795.239-.235.499-.409.78-.522.375-.153.808-.23 1.298-.23.887 0 1.595.265 2.126.796.534.53.8 1.267.8 2.212 0 .937-.263 1.67-.791 2.2-.529.528-1.235.792-2.119.792-.895 0-1.606-.263-2.135-.788C3.264 8.685 3 7.96 3 7.036Zm1.252-.04c0 .657.158 1.156.472 1.496C5.04 8.83 5.44 9 5.923 9c.484 0 .881-.168 1.19-.503.313-.338.469-.843.469-1.516 0-.665-.152-1.16-.456-1.488-.301-.327-.702-.49-1.203-.49-.5 0-.905.166-1.211.498-.307.33-.46.829-.46 1.496Z"
      />
    </svg>
  );
}
